import React from "react";
import "./ToSuccessStoriesSection.css";

import { motion } from "framer-motion";

const ToSuccessStoriesSection= ({
  title, 
}) => {
  return (
    <motion.section
        initial={{ opacity: 0, y: 80 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: false, amount: 0.3 }}
      >
      <section className="hero-section-success-stories">
        <div className="hero-container-success-stories">
          <h1>{title}</h1>
          
          <div className="button-group">
          <a 
            href="/book" 
            className="primary-btn" 
            style={{ textDecoration: 'none', display: 'inline-block' }}
          >
            Book a Demo
          </a>
          <a 
            href="/contact" 
            className="secondary-btn" 
            style={{ textDecoration: 'none', display: 'inline-block' }}
          >
            Contact
          </a>
        </div>
        </div>
      </section>
    </motion.section>
  );
};
export default ToSuccessStoriesSection;